module.exports = __webpack_public_path__ + "static/1-463c5fb85fefe90d8806702f0c4e1c69.jpg";